import React, { Component, useEffect, useState } from 'react';
import ExtraItem from './ExtraItemView';
import { getCurrency, callCartItemListeners, initOptionHeader, checkAllowAddService, getCurrencyCode } from '../../utils/common';
import { setOrderCache, order_key, addItemToCrosssell, addToCart, removeFromCart, setBeingSelected, getOrderCache } from '../../utils/order_cache';
import crmservices from '../../wsclient/crmservices';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
import {setTotalCartItem} from '../../utils/common';
import { newGUID } from '../../utils/util';
import t from '../../utils/translateUtil';
import ModalAlert from '../../components/ModalAlert';
import Loading from '../../components/Loading';
function ExtraItemController(props) {
    const [message, setMessage] = useState({});
    const [showLoading, onShowLoading] = useState(false);
    const [showLoadingUpsell, onShowLoadingUpSell] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState({});
    const [price_selected, setPriceSelected] = useState(undefined);
    const [variations, setVariations] = useState([]);
    const [variationSelected, setVariationSelected] = useState([]);
    const [product_detail, setProductDetail] = useState(undefined);
    const [variantsOrg, setVariantsOrg] = useState([]);
    const [quantity, setQuantity] = useState(1);
    const [totalAmount, setTotalAmount] = useState(0);
    const [orgAmount, setOrgAmount] = useState(0);
    const [components, setComponents] = useState([]);
    const [componentsSelected, setCompnentsSelected] = useState([]);
    const [componentRequireSelected, setComponentRequireSelected] = useState([]);
    const [productsFilter, setProductsFilter] = useState([]);
    const [upsellProducts, setUpsellProducts] = useState([]);
    const [showValidationVariant, onShowValidationVariant] = useState(false);
    const [crosssellProducts, setCrosssellProducts] = useState([]);
    const [notes, setNotes] = useState(null);
    const [isAllowUpdateComponent, setIsAllowUpdateComponent] = useState(props.mode && props.mode === 'edit' ? false : true);
    const [mode, setMode] = useState(props.mode && props.mode ? props.mode : 'add');
    const [order_info, setOrderInfo] = useState({
        selectedProduct: {},
        quantity: 1,
        totalAmount: 0,
        orgAmount: 0,
        componentsSelected: undefined,
        variationSelected: undefined,
        notes: null
    });
    const product_info = getOrderCache(order_key.being_selected_product);

    useEffect(()=>{
        init();
    },[])
    
    useEffect(() => {
        if (order_info.variationSelected && order_info.variationSelected.length > 0) {
            var productSelected = mode == 'edit' ? props.route.params.item : undefined;
            if ((productSelected && productSelected.type == 'COMPOSITE') || product_info.type == 'COMPOSITE') {
                loadProductComponents(order_info.variationSelected[0].id);
            }
            var _productsFilter = dataUtil.findProductByVariantAttributes(props.route.params.variations, order_info.variationSelected);
            setProductsFilter(_productsFilter)
            if (_productsFilter && _productsFilter.length == 1) {
                updateAmount(_productsFilter[0])
            }
        }
    }, [order_info.variationSelected]);

    useEffect(() => {
        if (price_selected) {
            updateAmountPriceTerm(price_selected)
        }
    }, [price_selected]);

    const init = async() =>{
       
        var variations = dataUtil.groupedVariantByAttributes(props.variations);
        var variationSelected = props.mode === 'edit' && props.variationSelected ? props.variationSelected : null;
        
       // console.log('variationSelected=====', variationSelected)
        var being_selected_product = await getOrderCache(order_key.being_selected_product);
        //console.log('being_selected_product=====', being_selected_product)
        var totalAmount = being_selected_product.amount;
        var quantity = being_selected_product.quantity;
        var orgAmount = being_selected_product.amount;
        notes = being_selected_product.notes?being_selected_product.notes: null
        var selectedProduct = props.product_selected ? props.product_selected : being_selected_product;
        var product_id = props.product_selected&&props.product_selected.default_product_id ? props.product_selected.default_product_id : being_selected_product.id;
        setSelectedProduct(selectedProduct);
        setVariantsOrg(props.variations);
        loadProductUpsells(product_id);


        if (!variationSelected){///set default select variant
            variationSelected = []
            if(variations&&variations.length >0){
                variations.forEach((variant)=>{
                    variationSelected.push({ key: variant.key, ...variant.variations[0] });
                })
            }

            // var productsFilter = dataUtil.findProductByVariantAttributes(props.variations, variationSelected);
            // this.setState({ productsFilter: productsFilter })
            // if(productsFilter && productsFilter.length == 1){
            //     this.updateAmount(productsFilter[0])
            // }
        }
        
        
        if (variationSelected) {
            variationSelected.forEach(selected => {
                totalAmount = onSelectedVariation(selected.key, selected, selectedProduct, true);
                orgAmount = totalAmount
            });
        }

        if (selectedProduct.type != 'COMPOSITE') {
            loadProductComponents(product_id);
        }
        else{
            setComponents([]);
        }

        var notes = null;
        if(props.product_selected){
            totalAmount = props.product_selected.totalAmount;
            quantity = props.product_selected.quantity;
            orgAmount = props.product_selected.price;
            notes = props.product_selected.notes ? props.product_selected.notes: null
        }
        setVariations(variations);
        setTotalAmount(totalAmount);
        setOrgAmount(orgAmount);
        
       // setSelectedProduct(selectedProduct);
        setNotes(notes)
        if (props.mode === 'edit') {
            var components_selected = props.product_selected.components_selected;
            if (components_selected) {
                setCompnentsSelected(components_selected);
            }
            setQuantity(props.product_selected.quantity);
        }
    }


    useEffect(() => {
        if(isAllowUpdateComponent){
            //console.log('selectedProduct====', selectedProduct)
            //console.log('components====', components)
            if (selectedProduct.type == 'FIXED_BUNDLE') {
                var totalAmount = 0;
                var componentsSelected = [];
                components.forEach(component => {
                    if (component.products && component.products.length > 0) {
                        let product = component.products[0];
                        var price = dataUtil.getProductPrice(product.pricing);
                        product.price = price;
                        //console.log("product:", product);
                        component.productSelected = [product];
                        componentsSelected.push(component);
                        totalAmount = totalAmount + (price * quantity);
                    }
                });
                totalAmount = (orgAmount * quantity) + totalAmount;

                setTotalAmount(totalAmount);
                setCompnentsSelected(componentsSelected);

            } else if (selectedProduct.type == 'COMPOSITE' || selectedProduct.type == 'FLEXIBLE_BUNDLE') {
                let componentsSelected = [];
                let totalAmount = 0;
                components.forEach(component => {
                    if (component.default_modifier && component.products && component.products.length > 0) {
                        let productExist = component.products.filter(p => {
                            return p.id == component.default_modifier.id
                        })
                        if (productExist && productExist.length > 0) {
                            let product = productExist[0];
                            var price = dataUtil.getProductPrice(product.pricing);
                            product.price = price;
                            component.productSelected = [product];
                            componentsSelected.push(component);
                            totalAmount = totalAmount + (price * quantity);
                        }
                    }
                });
                totalAmount = (orgAmount * quantity) + totalAmount;
                console.log('componentsSelected====', componentsSelected)
                setTotalAmount(totalAmount);
                setCompnentsSelected(componentsSelected);
            }
        }
    }, [components]);
    const onSelectComponent = (component, product) =>{
        //console.log("AAAAA component:", component)
        var newComponentsSelected = [...componentsSelected];
        if (product.id == 'None') {
            newComponentsSelected = newComponentsSelected.filter(function (cObj) {
                return cObj.id !== component.id;
            });

        } else {
            if (newComponentsSelected.length === 0) {
                component.productSelected = [product];
                newComponentsSelected.push(component);
            } else {
                var isExit = false;
                var maximum = component.maximum_quantity ? component.maximum_quantity : 0;
                for (var i = 0; i < newComponentsSelected.length; i++) {
                    if (newComponentsSelected[i].id === component.id) {
                        var productSelected = newComponentsSelected[i].productSelected;
                        var isProductExit = productSelected.filter(p => {
                            return p.id == product.id;
                        })
                        if (isProductExit && isProductExit.length > 0) {
                            let _pSelected = productSelected.filter(p => {
                                return p.id != isProductExit[0].id
                            })
                            newComponentsSelected[i].productSelected = _pSelected;
                        } else {
                            if (maximum > 1 && productSelected.length < maximum) {
                                productSelected.push(product);
                            } else if (maximum > 1 && productSelected.length == maximum) {
                                // do nothing
                            } else {
                                //console.log("AAAAAAA");
                                newComponentsSelected[i].productSelected = [product];
                            }
                        }
                        isExit = true;
                    }
                }
                if (!isExit) {
                    component.productSelected = [product];
                    newComponentsSelected.push(component);
                }
            }
            product.price = dataUtil.getProductPrice(product.pricing);
        }
        var totalAmount = 0;
        newComponentsSelected.forEach(element => {
            element.productSelected.forEach(p => {
                var price = p.price;
                if(price)
                    totalAmount = totalAmount + (price * quantity);
            });

        });
        totalAmount = (orgAmount * quantity) + totalAmount;
        console.log('AAAAA onSelectComponent orgAmount:',orgAmount)
        console.log('AAAAA onSelectComponent quantity:',quantity)
        console.log('AAAAA onSelectComponent totalAmount:',totalAmount)
        setCompnentsSelected(newComponentsSelected)
        setTotalAmount(totalAmount)
    }
    const onSelectedVariation = (key, item, product_selected, disableUpdateComponent, isUpSell) =>{
        console.log('onSelectedVariation product_selected==== ',product_selected)
        //console.log('onSelectedVariation item==== ',item)
        var newVariationSelected = isUpSell?[]:[...variationSelected];
        console.log('onSelectedVariation newVariationSelected==== ',newVariationSelected)
        if (newVariationSelected.length == 0) {
            newVariationSelected.push({ key: key, ...item });
        } else {
            const variantExit = newVariationSelected.find(variant => variant.key == key);
            if (!variantExit || variantExit.length == 0) {
                newVariationSelected.push({ key: key, ...item });
            } else {
                if (variantExit.value != item.value) {
                    newVariationSelected = newVariationSelected.filter(v => v.value != variantExit.value);
                    newVariationSelected.push({ key: key, ...item });
                }
            }
        }
        setVariationSelected(newVariationSelected);

        if(!disableUpdateComponent){ 
            setIsAllowUpdateComponent(true);
        }

        if ((product_selected &&product_selected.type == 'COMPOSITE')|| selectedProduct.type == 'COMPOSITE') {

            loadProductComponents(newVariationSelected[0].id);
        }
        var productsFilter = dataUtil.findProductByVariantAttributes(product_selected?props.variations: variantsOrg, newVariationSelected);
        setProductsFilter(productsFilter);

        if(productsFilter && productsFilter.length == 1){
             return updateAmount(productsFilter[0])
        }
      
    }
    const updateAmount = (item, increase) =>{
        var amount = dataUtil.getProductPrice(item.pricing);
        var totalAmount = 0;
        componentsSelected.forEach(element => {
            element.productSelected.forEach(p => {
                var price = p.price;
                totalAmount = totalAmount + (price * quantity);
            });

        });
        if (!increase) {
            totalAmount = totalAmount + (quantity * amount);
            setTotalAmount(totalAmount);
            setOrgAmount(amount);
            //console.log("totalAmount 222222222:",totalAmount);
        } else {
            totalAmount = totalAmount + (amount * quantity);
            setTotalAmount(totalAmount);
        }
        return totalAmount;
    }
    const loadProductComponents = async(productId) =>{
        onShowLoading(true);
        var component = [];
        try {
            var result = await crmservices.orders.getProductComponents(productId);
            console.log("loadProductComponents productId:", productId);
            console.log("loadProductComponents result:", result);
            if (result.code == 'OK') {
                if (result.data && result.data.length > 0) {
                    component = result.data;
                }
            }
        } catch (error) {
            console.log("load product component exception:", error);
        }
        onShowLoading(false);
        setComponents(component)
        return component;
    }

    const loadProductUpsells = async(productId) =>{
        onShowLoadingUpSell(true);
        var fullUpsellsInformation = [];
        var crossells = []
        try {
            var result = await crmservices.orders.getProductDetail(productId);
            if (result.code == 'OK') {
                if (result.data) {
                    updateProductPriceTerm(result.data);
                    var upsells = result.data.upsells ? result.data.upsells : [];
                    crossells = result.data.crosssells ? result.data.crosssells : [];
                    if (upsells.length > 0) {
                        for (let i = 0; i < upsells.length; i++) {
                            var upsell = upsells[i];
                            var detailResult = await crmservices.orders.getProductDetail(upsell.id);
                            if (detailResult.code == 'OK') {
                                upsell = { ...upsell, ...detailResult.data};
                            }
                            fullUpsellsInformation.push(upsell);
                        }
                    }
                }
            }
        } catch (error) {
            console.log("load product component exception:", error);
        }
        setCrosssellProducts({crosssells:crossells});
        onShowLoadingUpSell(false);
        setUpsellProducts(fullUpsellsInformation)
        return fullUpsellsInformation;
    }

    const onItemQuantityChange = (increase) =>{
        if(showLoading){
            return
        }
        var temp_quantity = quantity;
        if (increase) {
            temp_quantity = temp_quantity + 1;
        } else {
            if (temp_quantity > 1) {
                temp_quantity = temp_quantity - 1;
            }
        }
        var totalAmount = orgAmount * temp_quantity;
        if (componentsSelected.length > 0) {
            componentsSelected.forEach(element => {
                var products = element.productSelected;
                var amount = 0;
                products.forEach(product => {
                    amount = dataUtil.getProductPrice(product.pricing);
                    amount = amount * temp_quantity;
                });
                totalAmount = totalAmount + amount;
            });
        }
        //console.log('onItemQuantityChange==2=',totalAmount)
        setQuantity(temp_quantity);
        setTotalAmount(totalAmount);
    }

    const onAddToCart = async(default_product_id) =>{
        let _isAllowAddService = await checkAllowAddService();
        if (!_isAllowAddService) {
            showMessage(true, t('DEPENDENCY_FREE_TV_REQUIRED'))
            return;
        }
        //var { selectedProduct, variationSelected, componentsSelected, quantity, totalAmount, orgAmount, productsFilter, variantsOrg, notes } = this.state;
        if ((variantsOrg.length > 0 && variationSelected.length > 0 &&  productsFilter.length > 1) || (variantsOrg.length > 0 && variationSelected.length ==0)) {
            onShowValidationVariant(true);
        }else if (variantsOrg.length > 0 && (!productsFilter || productsFilter.length == 0)) {
            showMessage(true, t('EXCEPTION_PROCESS') );
            onShowValidationVariant(false);
        } else {
            onShowValidationVariant(false)
            var temp_components = [];
            var productFilter = productsFilter[0];
            var componentRequireSelected = dataUtil.validateComponents(components, componentsSelected);
            if (componentRequireSelected.length === 0) {
                if (componentsSelected.length > 0) {
                    componentsSelected.forEach(element => {
                        var products = element.productSelected;
                        products.forEach(product => {
                            var price = dataUtil.getProductPrice(product.pricing);
                            product.price = price;
                            product.quantity = quantity;
                            temp_components.push(product);
                        });
                    });
                }
                var productToBeAdded = {
                    id: variantsOrg.length > 0 ? productFilter.id : selectedProduct.id,
                    default_product_id: default_product_id ? default_product_id : selectedProduct.id,
                    key: newGUID(),
                    name: selectedProduct.name,
                    description: selectedProduct.description,
                    variant_selected: variationSelected,
                    components_selected: componentsSelected,
                    quantity: quantity,
                    totalAmount: totalAmount,
                    price: orgAmount,
                    creatives: selectedProduct.creatives,
                    variations: props.variations,
                    notes: notes,
                    type: selectedProduct.type,
                    classification: product_detail.classification,
                    price_selected: price_selected

                }
                if (temp_components.length > 0) {
                    productToBeAdded.components = temp_components;
                }
                if(crosssellProducts){ 
                    var temp_crosssellProducts = {...crosssellProducts}
                    temp_crosssellProducts.product_id = productToBeAdded.key
                    addItemToCrosssell(temp_crosssellProducts)
                }
                //console.log('productToBeAdded:', productToBeAdded);
                await addToCart(productToBeAdded);
                callCartItemListeners(true);
                props.setActivePage();
            } else {
                setComponentRequireSelected(componentRequireSelected);
            }
        }
    }
    const onUpdateToCart = async() =>{
        if(showLoading){
            return
        }
        await removeFromCart(props.product_selected);
      //  console.log('variationSelected===',variationSelected)
        var productsFilter = dataUtil.findProductByVariantAttributes(variantsOrg, variationSelected);
        setProductsFilter(productsFilter);
        await onAddToCart(props.product_selected.default_product_id);
    }
    const onSelectUpsellProduct = async(upsell_product) =>{
        console.log('upsell_product=====', upsell_product);

        onShowLoading(true);
        try {
            var sortProductItem = {
                amount: dataUtil.getProductPrice(upsell_product.pricing),
                creatives: upsell_product.creatives,
                description:upsell_product.description,
                id: upsell_product.id,
                name: upsell_product.name,
                org_product_name: upsell_product.name,
                type: upsell_product.type_composition,
                quantity:1
            }
            setVariationSelected([])
            setCompnentsSelected([]);
            await updateSelectedProduct(sortProductItem, true);
            
           // await cache.setBeingSelected(sortProductItem);
            if (sortProductItem.type != 'COMPOSITE') {
                loadProductComponents(upsell_product.id);
            }

            await setBeingSelected(sortProductItem);
            loadProductUpsells(upsell_product.id);
            //
            setNotes('')
        } catch (error) {
            console.log(" select upsell product exception:", error);
        }
        onShowLoading(false);
    }
    const updateSelectedProduct = async(product, isUpSell) =>{
        var variations = [];
        if(product.type){ 
            if(product.type == 'FLAT' || product.type=='COMPOSITE' || product.type=='FLEXIBLE_BUNDLE'){ 
                try {
                    var result = await crmservices.orders.getProductVariations(product.id, getOrderCache(order_key.order_type, true));
                    if (result.code == 'OK' && result.data && result.data.length > 0) {
                        variations = result.data;
                    }
                } catch (error) {
                    console.log("load product component exception:", error);
                }
            }
        }
        var variantGrouped = dataUtil.groupedVariantByAttributes(variations);

        let totalAmount = product.amount
        let orgAmount = product.amount
        if (variantGrouped.length > 0) {
            let selected = variantGrouped[0];
            if (selected.variations.length > 0) {
                totalAmount = await onSelectedVariation(selected.key, selected.variations[0], product, null, isUpSell)
                orgAmount = totalAmount
            }
        }

        setVariations(variantGrouped);
        setSelectedProduct(product);
        setTotalAmount(totalAmount);
        setOrgAmount(orgAmount);
        setQuantity(product.quantity);
        setVariantsOrg(variations);
    }

    const showMessage = (status, message) =>{
        onShowLoading(false);
        setMessage({
            show: status,
            content: message ? message : null
        });
    }

    const handleOnChangeNote = (event) =>{
        if (event && event.target && event.target.value) {
            setNotes(event.target.value);
        } else {
            setNotes(null);
        }
    }

    const updateAmountPriceTerm = (priceTerm,increase) => {
        var quantity = order_info.quantity;
        var amount = priceTerm.price ? priceTerm.price : 0;
        var totalAmount = 0;
        componentsSelected.forEach(element => {
            element.productSelected.forEach(p => {
                var price = p.price;
                totalAmount = totalAmount + (price * quantity);
            });

        });
        if (!increase) {
            totalAmount = totalAmount + (quantity * amount);
            setOrgAmount(amount);
        } else {
            totalAmount = totalAmount + (amount * quantity);
        }
        setTotalAmount(totalAmount);
    }

    const onSelectPriceTerm = (price) => {
        setPriceSelected(price);
    }
    const updateProductPriceTerm = (product) => {
        let _product = { ...product };
        if(product && product.classification == "TERMED_SERVICE"){
            if(product.pricing && product.pricing.length > 0){
                let pricing = product.pricing.sort(dataUtil.sortPrice);
                let currencyCode = getCurrencyCode();
                let _priceByCurrencyCode = pricing?.filter(x => x.currency == currencyCode);
                _product.pricing = _priceByCurrencyCode;
                setPriceSelected(_priceByCurrencyCode?.[0]);
            }
        }
        setProductDetail(_product);
    }
    console.log('variationSelected===', variationSelected)
    return (
        <div>
            <ExtraItem
                open={props.open}
                onClose={props.onClose}
                showLoading={showLoading&&showLoadingUpsell}
                currency={props.currency}
                selectedProduct={selectedProduct}
                variations={variations}
                variationSelected={variationSelected}
                components={components}
                componentsSelected={componentsSelected}
                quantity={quantity}
                totalAmount={totalAmount}
                notes={notes}
                product_detail={product_detail}
                price_selected={price_selected}
                onItemQuantityChange={onItemQuantityChange}
                onSelectedVariation={onSelectedVariation}
                onSelectComponent={onSelectComponent}
                onAddToCart={onAddToCart}
                onUpdateToCart={onUpdateToCart}
                onGoBack={props.setActivePage}
                mode={props.mode}
                componentRequireSelected={componentRequireSelected}
                showValidationVariant={showValidationVariant}
                upsellProducts={upsellProducts}
                onSelectUpsellProduct={onSelectUpsellProduct}
                handleOnChangeNote={handleOnChangeNote}
                onSelectPriceTerm={onSelectPriceTerm}
            />
            {message && <ModalAlert
                open={message.show}
                onClose={showMessage}
                message={message.content}
            />}
            {showLoading&&<Loading showLoading={showLoading}/>}
        </div>
    );
}

export default ExtraItemController;